import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { getStoredToken } from '../utils/authToken.js';
/**
 * Renders a protected file as an object URL.
 *
 * Authorization is carried by the httpOnly session cookie (credentials: 'include').
 * A token is NEVER placed in the URL, so this is safe for <img> rendering.
 * The object URL is always released on unmount or src change.
 */
export const AuthenticatedFileImage = ({ src, alt = 'file', className = '', testId }) => {
    const [objectUrl, setObjectUrl] = useState('');
    const [state, setState] = useState('loading');
    useEffect(() => {
        if (!src) {
            setState('error');
            return undefined;
        }
        let created = '';
        let cancelled = false;
        setState('loading');
        setObjectUrl('');
        (async () => {
            try {
                const token = getStoredToken();
                const response = await fetch(src, { credentials: 'include', headers: token ? { Authorization: `Bearer ${token}` } : {} });
                if (!response.ok)
                    throw new Error(`file_fetch_failed_${response.status}`);
                const blob = await response.blob();
                if (cancelled)
                    return;
                created = URL.createObjectURL(blob);
                setObjectUrl(created);
                setState('ready');
            }
            catch (error) {
                if (!cancelled)
                    setState('error');
            }
        })();
        return () => {
            cancelled = true;
            if (created)
                URL.revokeObjectURL(created);
        };
    }, [src]);
    if (state === 'loading') {
        return (_jsx("div", { className: "w-full h-full flex items-center justify-center", "data-testid": testId ? `${testId}-loading` : 'authenticated-file-loading', children: _jsx(Loader2, { size: 18, className: "animate-spin opacity-60" }) }));
    }
    if (state === 'error') {
        return (_jsx("div", { className: "w-full h-full flex items-center justify-center", title: "\u062A\u0639\u0630\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0644\u0641", "data-testid": testId ? `${testId}-error` : 'authenticated-file-error', children: _jsx(AlertTriangle, { size: 18, className: "opacity-60" }) }));
    }
    return (_jsx("img", { src: objectUrl, alt: alt, className: className, "data-testid": testId || 'authenticated-file-image' }));
};
export default AuthenticatedFileImage;
